import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import Scrollbars from "Components/scrollbars";
import WithModal from "Components/withModal";
import React, { useEffect, useState } from "react";
import { SIZES } from "../constants";
const defaultPreviewSettings = {
    show: false,
    text: ""
};
export default function Text(props) {
    const [previewSettings, setPreviewSettings] = useState(defaultPreviewSettings);
    useEffect(() => {
        if (!props.text || !props.show) {
            setPreviewSettings(prev => ({ ...prev, show: false }));
            return;
        }
        setPreviewSettings({
            show: true,
            text: props.text
        });
    }, [props.show, props.text]);
    if (!props.text)
        return null;
    return (React.createElement(WithModal, { show: previewSettings.show, onHide: props.onHide, shadingColor: shadingLightestColor, className: "bg-blur", maxHeight: `calc(100vh - ${SIZES.PREVIEW_WINDOW_OFFSET * 2}px)`, maxWidth: `calc(100vw - ${SIZES.PREVIEW_WINDOW_OFFSET * 2}px)`, width: SIZES.PREVIEW_MAX_WIDTH, height: SIZES.PREVIEW_MAX_HEIGHT, resizeEnabled: false, dragEnabled: false, title: props.title, headerOutsideModal: true, showTitle: true, closeBtn: true, contentClassName: "p-lg" },
        React.createElement(Scrollbars, { extraRightSpace: true },
            React.createElement("div", { className: "pre-wrap break-word" }, previewSettings.text))));
}
